/* eslint-disabled */
import Parrainage from "./Parrainage";
import Device from "./Device";
import Query from "./Query";
import CustomerSelfcareExtend from "@/entity/extends/CustomerSelfcareExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class CustomerSelfcare extends CustomerSelfcareExtend {

public id = '';
public phone = '';
public roles: string[] = [];
public password = '';
public email? = '';
public name? = '';
public prename? = '';
public photo? = '';
public blocked? = '';
public code? = '';
public parrainages: Array<Parrainage> = [];
public affiliation!: Parrainage;
public devices: Array<Device> = [];
public queries: Array<Query> = [];
public uuid = '';
public createdAt?: Date;
public updatedAt?: Date;
public createdFromIp? = '';
public updatedFromIp? = '';
public createBy? = '';
public verificationCode? = '';
public verificationCodeGeneratedAt?: Date;
public verificationFailedCount?: number;
public verified? = '';

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.phone= object.phone;
       this.roles= object.roles;
       this.password= object.password;
       this.email= object.email;
       this.name= object.name;
       this.prename= object.prename;
       this.photo= object.photo;
       this.blocked= object.blocked;
       this.code= object.code;
            hydrateCollection(object.parrainages, Parrainage, this.parrainages);
this.affiliation = (object.affiliation instanceof Parrainage) ? object.affiliation : object.affiliation ? new Parrainage(object.affiliation) : object.affiliation;
            hydrateCollection(object.devices, Device, this.devices);
            hydrateCollection(object.queries, Query, this.queries);
       this.uuid= object.uuid;
       if(object.createdAt){
           this.createdAt= new Date(object.createdAt);
       }
       if(object.updatedAt){
           this.updatedAt= new Date(object.updatedAt);
       }
       this.createdFromIp= object.createdFromIp;
       this.updatedFromIp= object.updatedFromIp;
       this.createBy= object.createBy;
       this.verificationCode= object.verificationCode;
       if(object.verificationCodeGeneratedAt){
           this.verificationCodeGeneratedAt= new Date(object.verificationCodeGeneratedAt);
       }
       this.verificationFailedCount= object.verificationFailedCount;
       this.verified= object.verified;
      }
      this.postConstruct()
  }

}
